import { isDefined } from '@sgme/fp';
import { v4 } from 'uuid';

import type { SavedSwapNds } from '@/domain/WorkspaceForex/savedProducts/swap/SavedSwapNds.ts';
import type { SavedSwapRegular } from '@/domain/WorkspaceForex/savedProducts/swap/SavedSwapRegular.ts';
import type { FxSwap } from '@/store/swap/state.ts';

export const mapToFxSwap = (savedProduct: SavedSwapRegular | SavedSwapNds): FxSwap => {
  const { isNonDeliverable } = savedProduct;

  return isNonDeliverable ? SavedSwapNdsToFxSwap(savedProduct) : SavedSwapRegularToFxSwap(savedProduct);
};

function SavedSwapRegularToFxSwap(savedProduct: SavedSwapRegular): FxSwap {
  const { properties } = savedProduct;

  const [currency1, currency2] = properties.currencyPair?.split('/') ?? [undefined, undefined];

  return {
    type: 'FxSwap',
    isNonDeliverable: false,
    clientId: savedProduct.clientId,
    properties: {
      currencyPair: properties.currencyPair,
      currency1,
      currency2,
      nearNotional: properties.nearNotional,
      nearNotionalCurrencyIndex: properties.currencyIndex,
      nearExpiryDateTenor: properties.nearExpiryDateTenor,
      farNotional: properties.farNotional,
      farNotionalCurrencyIndex: properties.currencyIndex,
      farExpiryDateTenor: properties.farExpiryDateTenor,
      farPrice: properties.farPrice,
      nearPrice: properties.nearPrice,
      type:
        isDefined(properties.nearPrice) || isDefined(properties.farPrice)
          ? 'historical'
          : properties.nearNotional === properties.farNotional
            ? 'standard'
            : 'uneven',
    },

    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  };
}

function SavedSwapNdsToFxSwap(savedProduct: SavedSwapNds): FxSwap {
  const { properties } = savedProduct;

  const [currency1, currency2] = properties.currencyPair?.split('/') ?? [undefined, undefined];

  return {
    type: 'FxSwap',
    isNonDeliverable: true,
    clientId: savedProduct.clientId,
    properties: {
      currencyPair: properties.currencyPair,
      currency1,
      currency2,
      nearNotional: properties.nearNotional,
      nearNotionalCurrencyIndex: properties.currencyIndex,
      nearExpiryDateTenor: properties.nearExpiryDateTenor,
      farNotional: properties.farNotional,
      farNotionalCurrencyIndex: properties.currencyIndex,
      farExpiryDateTenor: properties.farExpiryDateTenor,
    },

    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  };
}
